import Select, { components } from 'react-select';

const DropdownIndicator =
  (size: string = 'default') =>
  (props) => {
    const sizes: Record<string, { w: number; h: number; stroke: number }> = {
      small: { w: 18, h: 18, stroke: 1.5 },
      medium: { w: 20, h: 20, stroke: 3 },
      large: { w: 30, h: 30, stroke: 1 },
      default: { w: 20, h: 20, stroke: 3 },
    };

    const { w, h, stroke } = sizes[size] || sizes.medium;

    return (
      <components.DropdownIndicator {...props}>
        <svg
          width={w}
          height={h}
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </components.DropdownIndicator>
    );
  };

const SelectBox = (props) => {
  const { components, arrowSize = 'default' } = props;

  return (
    <>
      {props.label && <label>{props.label}</label>}
      <Select
        {...props}
        name={props.name}
        value={props.value}
        options={props.options}
        isMulti={props.isMulti}
        onChange={(value) => props.onChange(value)}
        placeholder={props.placeholder}
        formatOptionLabel={props.formatOptionLabel}
        components={components ? components : { DropdownIndicator: DropdownIndicator(arrowSize) }}
      />
      {props.touched && props.errors && (
        <div className="pb-0 invalid-feedback d-block invalid-feedback">{props.touched && props.errors} </div>
      )}
    </>
  );
};
export default SelectBox;
